import produce from 'immer';

export const initialState = {
  questions: [],
  loadingQuestions: false,
};

const HomePageReducer = (state = initialState, action) =>
  produce(state, () => {
    switch (action.type) {
      default:
        break;
    }
  });

export default HomePageReducer;
